import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
    ViewEncapsulation,
} from '@angular/core';

export type MatCardInfoType = 'info' | 'warn' | 'error';

const ICON_MAP: Map<MatCardInfoType, string> = new Map([
    ['info', 'info_outline'],
    ['warn', 'warning'],
    ['error', 'error'],
]);

type PaletteColor = 'warn' | 'accent' | 'primary' | string;

@Component({
    selector: 'ui-card-info',
    templateUrl: './ui-card-info.component.html',
    styleUrls: ['./ui-card-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiCardInfoComponent {
    @HostBinding('class')
    public hostClass = 'ui-card-info';

    @Input()
    public set type(type: MatCardInfoType) {
        if (!type || this._type === type) { return; }
        this._type = type;

        this._typeColor = this._computeColor(this.type);
    }
    public get type() {
        return this._type;
    }

    @Input()
    @HostBinding('attr.color')
    public set color(value: PaletteColor) {
        this._color = value;
    }
    public get color() { return this._color || this._typeColor; }

    @Input()
    public set icon(ico: string) {
        this._icon = ico;
    }

    public get icon() {
        return this._icon || ICON_MAP.get(this.type)!;
    }

    @Input()
    public message = '';

    private _icon?: string;
    private _type: MatCardInfoType = 'info';
    private _typeColor = this._computeColor(this._type);
    private _color?: PaletteColor;

    private _computeColor(type: MatCardInfoType): PaletteColor {
        switch (type) {
            case 'error':
            case 'warn':
                return 'warn';

            case 'info':
            default:
                return 'accent';
        }
    }
}
